<div class="companies-filter__container-outer">
  <form [formGroup]="form" class="companies-filter__container-inner">
    <div class="companies-filter__filter" *ngFor="let used of usedFilters; let uIdx = index">
      <button class="companies-filter__filter-remove  vox-btn vox-btn-secondary-grey"
        type="button"
        (click)="removeFilter(uIdx)"
        [ngClass]="{'hidden': usedFilters.length === 1}">
        <i class="companies-filter__filter-remove_symbol icon-small-remove"></i>
      </button>
      <div ngbDropdown class="vox-dropdown-input companies-filter__filter-dropdown">
        <button class="companies-filter__filter-dropdown_btn"
          id="filter-dropdown"
          ngbDropdownToggle
          [disabled]="availableFilters.length < 1">
          {{'companies.filters.' + used | translate}}
        </button>
        <div ngbDropdownMenu aria-labelledby="filter-dropdown">
          <button ngbDropdownItem class="companies-filter__filter-dropdown_item"
            type="button"
            *ngFor="let filter of availableFilters; let idx = index" (click)="updateFilters(idx, uIdx)">
            {{'companies.filters.' + filter | translate}}
          </button>
        </div>
        <div class="companies-filter__filter-input" [ngSwitch]="used">
          <div class="companies-filter__filter-input_name vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="name" *ngSwitchCase="'name'"
              (keydown.enter)="emitFilters($event)">
          </div>
          <div class="companies-filter__filter-input_name vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="id" *ngSwitchCase="'id'"
            (keydown.enter)="emitFilters($event)">
          </div>
          <div class="companies-filter__filter-input_name vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="alphaname" *ngSwitchCase="'alphaname'"
            (keydown.enter)="emitFilters($event)">
          </div>
          <div class="companies-filter__filter-input_name vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="email" *ngSwitchCase="'email'"
              (keydown.enter)="emitFilters($event)">
          </div>
          <div class="companies-filter__filter-input_name vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="did" *ngSwitchCase="'did'"
            (keydown.enter)="emitFilters($event)">
          </div>
          <div class="companies-filter__filter-input_name vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="billingId" *ngSwitchCase="'billingId'"
              (keydown.enter)="emitFilters($event)">
          </div>
        </div>
      </div>
    </div>
    <div class="companies-filter__filter-add_container">
      <button class="vox-btn vox-btn-secondary companies-filter__filter-add"
        type="button"
        (click)="addFilter(0)"
        [disabled]="availableFilters.length < 1">
        <i class="companies-filter__filter-add_symbol icon-small-add">
        </i>
      </button>
      <button class="vox-btn vox-btn-secondary companies-filter__filter-apply"
        type="submit"
        [disabled]="form.invalid"
        (click)="emitFilters(null)">
        {{'companies.actions.apply-filters' | translate}}
      </button>
      <button class="ml-2 btn btn-link companies-filter__filter-clear"
        type="button"
        (click)="resetFilters()">
        {{'companies.actions.clear-filters' | translate}}
      </button>
    </div>
  </form>
</div>
